import React from 'react'

import IconBase, { IconProps } from './IconBase'

const IconFrameBounds = ({ size, className }: IconProps) => (
  <IconBase size={size} className={className}>
    <path
      d="m6.8511 3.7617c0-0.34124-0.27663-0.61787-0.61787-0.61787s-0.61787 0.27663-0.61787 0.61787v1.8536h-1.8536c-0.34124 0-0.61787 0.27663-0.61787 0.61787s0.27663 0.61787 0.61787 0.61787h1.8536v10.298h-1.8536c-0.34124 0-0.61787 0.27664-0.61787 0.61787 0 0.34123 0.27663 0.61787 0.61787 0.61787h1.8536v1.8536c0 0.34123 0.27663 0.61787 0.61787 0.61787s0.61787-0.27664 0.61787-0.61787v-1.8536h10.298v1.8536c0 0.34123 0.27664 0.61787 0.61787 0.61787 0.34123 0 0.61787-0.27664 0.61787-0.61787v-1.8536h1.8536c0.34123 0 0.61787-0.27664 0.61787-0.61787 0-0.34123-0.27664-0.61787-0.61787-0.61787h-1.8536v-10.298h1.8536c0.34123 0 0.61787-0.27663 0.61787-0.61787s-0.27664-0.61787-0.61787-0.61787h-1.8536v-1.8536c0-0.34124-0.27664-0.61787-0.61787-0.61787-0.34123 0-0.61787 0.27663-0.61787 0.61787v1.8536h-10.298zm10.298 13.387v-10.298h-10.298v10.298z"
      clipRule="evenodd"
      fillRule="evenodd"
      strokeWidth=".82382"
    />
  </IconBase>
)

export default IconFrameBounds
